import type { FC, PropsWithChildren, ReactNode } from 'react'
import { Children, isValidElement } from 'react'

import { isObject } from '../../guards'
import { nodeToElement } from './helpers'

type SwitchProps = {
  fallback?: ReactNode
}

export const Switch: FC<PropsWithChildren<SwitchProps>> = ({ children, fallback }) => {
  for (const child of Children.toArray(children)) {
    if (
      isValidElement(child) &&
      isObject(child.props) &&
      'when' in child.props &&
      child.props.when
    ) {
      return child
    }
  }

  return nodeToElement(fallback)
}
